import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-line px-6 py-10 text-center">
      <h3 className="font-display text-base font-semibold text-ink">{title}</h3>
      {description ? <p className="max-w-xs text-sm text-ink-muted">{description}</p> : null}
      {action}
    </div>
  );
}
